import * as XLSX from 'xlsx';

interface ExcelDownloadProps {
  headers: { label: string; key: string }[];
  data: any[];
  fileName: string;
  sheetName?: string;
}

export const downloadExcel = ({
  headers,
  data,
  fileName,
  sheetName = 'Sheet1',
}: ExcelDownloadProps) => {
  const wb = XLSX.utils.book_new();

  const headerRow = headers.map((h) => h.label);
  const dataRows = data.map((row) => headers.map((h) => row[h.key]));
  const sheetData = [headerRow, ...dataRows];
  const ws = XLSX.utils.aoa_to_sheet(sheetData);

  XLSX.utils.book_append_sheet(wb, ws, sheetName);
  XLSX.writeFile(wb, `${fileName}.xlsx`);
};

// 사용 예시:
// downloadExcel({
//   data: [
//     { name: 'John', age: 30 },
//     { name: 'Jane', age: 25 }
//   ],
//   fileName: 'users',
//   sheetName: 'Users'
// });
